// extracted by mini-css-extract-plugin
export default {"loader":"Comets_loader__wobMM","load6":"Comets_load6__SzwQ9","round":"Comets_round__s027d"};